<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    西丽站<br>
站点介绍<br>
西丽站为地铁5、7号线的换乘站。车站位于南山区西丽镇留仙大道和沙河西路十字路口处，其中5号线西丽站沿留仙大道东西向布置于路口西侧，7号线西丽站沿沙河西路跨路口四线平行布置，5号线和7号线形成T字方式换乘。车站西南角位于留仙大道南侧，有西丽街道办事处、壮丽大厦、西丽幼儿园等，车站东南角位于沙河西路东侧，有丽苑阁、西丽法庭等，车站东北角位于沙河西路东侧，是天虹商场、电子城等商业区，西北角位于沙河西路西侧，有新围村、366大街、深圳职业技术学院等。西丽站装修风格以绿色为主，突出青春活力；站内采用现代节能科技LED灯饰和节能灯管，突出环保理念。 该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:10	23:47	5号线	3分钟	5分25秒<br>
黄贝岭	06:19	23:34	5号线	3分钟	5分25秒<br>
西丽湖	06:20	23:54	7号线	3分35秒	5分55秒<br>
太安	06:18	23:02	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	23:47	5号线	4分钟	6分钟<br>
黄贝岭	06:28	23:34	5号线	4分钟	6分钟<br>
西丽湖	06:25	23:54	7号线	4分钟	5分55秒<br>
太安	06:22	23:02	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	00:47	5号线	4分钟	6分钟<br>
黄贝岭	06:28	00:34	5号线	4分钟	6分钟<br>
西丽湖	06:25	00:54	7号线	4分钟	5分55秒<br>
太安	06:22	00:02	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
留仙大道南侧、 西丽街道办事处,南方科技大学医院、南山区西丽社工服务中心、留仙苑、石鼓山公园<br><br>
B出入口:<br>
丽兰苑、西丽工业区、沙河西路西侧（南）<br><br>
C出入口:<br>
沙河西路东侧（南）、西丽人民法庭、 众冠西郡园<br><br>
D出入口:<br>
沙河西路东侧（北）、南国丽城、西丽小学、九祥岭村<br><br>
E出入口:<br>
沙河西路西侧（北）、同沙路西侧、新围社区工作站、丽新花园、深圳职业技术学院东校区<br><br>
F出入口:<br>
留仙大道北侧、鼎新大厦、留仙居、新围村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 南方科技大学医院站<br>
122、122快线、235、B708、M109、M176、M197、M393Q、M393、M429、M488、M539<br><br>
B出入口:<br>
公交站名： 西丽法庭②站<br>
101、104、19、226、36、66、67Q、67、74、81、M109、M299、M492、M539、N8、高峰专线43路<br><br>
B出入口:<br>
公交站名： 西丽法庭①站<br>
235、316A、316Q、316、316区间、325、325A、325Q、326、332、392、B708、E19、M203、M343、M345、M369、M372、M385、M429、M488、M535、M554、高峰专线166<br><br>
C出入口:<br>
公交站名： 西丽法庭①站<br>
235、316A、316Q、316、316区间、325、325A、325Q、326、332、392、B708、E19、E39、M109、M203、M343、M345、M369、M372、M385、M429、M488、M535、M539、M554、高峰专线166、高峰专线43<br><br>
C出入口:<br>
公交站名： 西丽法庭②站<br>
101、104、226、36、66、67Q、67、74、81、M299、M492<br><br>
C出入口:<br>
公交站名： 众冠花园站<br>
122快线、M385、M369、M393、M459、M554、36、74、81、122、M299、M343<br><br>
D出入口:<br>
公交站名： 九祥岭①站<br>
101、104、226、66、M176、M492<br><br>
D出入口:<br>
公交站名： 九祥岭②站<br>
101、226、326、332、392、66、67、M197、M217、104、316、316区间、325、M203、M345、M372、高峰专线166、高峰专线43、M535<br><br>
D出入口:<br>
公交站名： 众冠花园站<br>
122快线、19、M385<br><br>
E出入口:<br>
公交站名： 九祥岭②站<br>
101、226、326、332、392、66、104、316、325、67、M203、M345、M535、高峰专线43、M197、M217、316区间、M372、高峰专线166<br><br>
E出入口:<br>
公交站名： 九祥岭①<br>
M176、M197、M459、M4926、M182、M492、B797<br><br>
F出入口:<br>
公交站名： 新围村站<br>
M393、M176、M182、M197、M459<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "wuhaoxian",
          title: "5号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>


